<template>
    <div class="page">
        <router-link :to="{ name: 'LoginClient' }" tag="h1" class="">Inloggen als opdrachtgever</router-link>
        <p class="mb-5">Inloggen als opdrachtgever. Problemen of vragen over het inloggen?
            Neem <router-link :to="{ name: 'SecurityContact' }" tag="a">contact</router-link> met ons op.
        </p>
        <form @submit.prevent="login">
            <div class="form-group">
                <label for="username" hidden>Email</label>
                <input :class="['form-control', failedLogin ? 'is-invalid' : failedLogin == null ? '' : 'is-valid']" placeholder="Email..." type="email" required name="username" id="username" v-model="user.userName" :disabled="isLoading">
            </div>
            <div class="form-group">
                <label for="password" hidden>Wachtwoord</label>
                <input :class="['form-control', failedLogin ? 'is-invalid' : failedLogin == null ? '' : 'is-valid']" placeholder="Wachtwoord..." type="password" required name="password" id="password" v-model="user.password" :disabled="isLoading">
                <div class="invalid-feedback">
                    Gebruikersnaam en wachtwoord komen niet overeen.
                </div>
            </div>
            <div class="custom-control custom-checkbox text-right mb-3">
                <input class="custom-control-input" type="checkbox" value="" id="rememberMe"  v-model="user.rememberMe"  :disabled="isLoading" >
                <label class="custom-control-label" for="rememberMe">
                    Ingelogd blijven?
                </label>
            </div>
            <div class="form-group text-right">
                <loader width="3rem" class="mr-3" v-if="isLoading"></loader>
                <button type="submit" class="btn btn-half btn-outline-azure btn-lg"  :disabled="isLoading" v-else>
                    <span>Inloggen als <br /> opdrachtgever</span>
                    <div class="btn-icon">
                        <span>&rarr;</span>
                    </div>
                </button>
                <br>
            </div>
            <div class="form-check text-right">
                <small><router-link tag="a" :to="{ name: 'ForgotPassword' }">Wachtwoord vergeten?</router-link></small>
            </div>
        </form>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
    components: {
        Loader
    },
    data() {
        return {
            user: {
                userName: '',
                password: '',
                rememberMe: false,
                type: 'Client'
            },
            isLoading: false,
            failedLogin: null
        }
    },
    methods: {
        login() {
            this.isLoading = true;
            this.$store.dispatch('AUTH_LOGIN', this.user).then(() => {
                if(this.$store.getters.isAuthenticated)
                {
                    this.failedLogin = false;
                    this.$router.push({ name: this.user.type })
                } else {
                    this.failedLogin = true;
                }
                this.isLoading = false;
            }).catch(() => {
                this.failedLogin = true;
                this.isLoading = false;
            })
        }
    }
}
</script>
